const RISE_CLASS = 'scroll-reveal';
const FADE_CLASS = 'scroll-reveal--fade';
const RISE_DISTANCES_PIXELS = [63, 131, 144, 177];
const FADE_DURATION_MS = 300;
const RISE_DURATION_MS = 780;
const EASE_OUT_QUAD = 'cubic-bezier(0.5, 1, 0.89, 1)';
const MIDLINE_ROOT_MARGIN = '-50% 0px -50% 0px';
const TOUCHING_EDGE_ROOT_MARGIN = '-2px 0px -2px 0px';

function isElementorEditor() {
    return document.body.classList.contains('elementor-editor-active');
}

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function sectionOf(element) {
    const section = element.closest('section');

    return section === null ? element.parentElement : section;
}

function groupBySection(elements) {
    const groups = new Map();

    elements.forEach((element) => {
        const section = sectionOf(element);

        if (section === null) {
            return;
        }

        if (!groups.has(section)) {
            groups.set(section, { elements: [], isShown: false, isFirstCheck: true });
        }

        groups.get(section).elements.push(element);
    });

    return groups;
}

function enteredFromTop(entry) {
    if (entry.rootBounds === null) {
        return true;
    }

    const midline = entry.rootBounds.top;

    return midline - entry.boundingClientRect.top <= entry.boundingClientRect.bottom - midline;
}

function hideGroup(group) {
    group.isShown = false;

    group.elements.forEach((element) => {
        element.getAnimations().forEach((animation) => animation.cancel());
        element.style.opacity = '0';
    });
}

function showGroup(group, shouldAnimate) {
    if (group.isShown) {
        return;
    }

    group.isShown = true;

    let risePosition = 0;

    group.elements.forEach((element) => {
        element.style.opacity = '';

        if (!shouldAnimate) {
            return;
        }

        element.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FADE_DURATION_MS, easing: EASE_OUT_QUAD });

        if (!element.classList.contains(RISE_CLASS)) {
            return;
        }

        const distance = RISE_DISTANCES_PIXELS[Math.min(risePosition, RISE_DISTANCES_PIXELS.length - 1)];

        element.animate(
            [{ transform: 'translateY(' + distance + 'px)' }, { transform: 'translateY(0)' }],
            { duration: RISE_DURATION_MS, easing: EASE_OUT_QUAD }
        );
        risePosition += 1;
    });
}

function animateOnlyWhenEnteringFromTop(groups) {
    return new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const group = groups.get(entry.target);
            const isFirstCheck = group.isFirstCheck;

            group.isFirstCheck = false;

            if (entry.isIntersecting) {
                showGroup(group, isFirstCheck || enteredFromTop(entry));
            }
        });
    }, { rootMargin: MIDLINE_ROOT_MARGIN });
}

function resetWhenLeavingThroughBottom(groups) {
    return new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const group = groups.get(entry.target);

            if (entry.isIntersecting) {
                if (entry.intersectionRatio >= 0.99) {
                    showGroup(group, true);
                }

                return;
            }

            if (entry.boundingClientRect.top > 0) {
                hideGroup(group);
            } else {
                showGroup(group, false);
            }
        });
    }, { rootMargin: TOUCHING_EDGE_ROOT_MARGIN, threshold: [0, 0.99] });
}

function startScrollReveal() {
    if (isElementorEditor() || prefersReducedMotion()) {
        return;
    }

    const elements = Array.from(document.querySelectorAll('.' + RISE_CLASS + ', .' + FADE_CLASS));
    const groups = groupBySection(elements);
    const enterObserver = animateOnlyWhenEnteringFromTop(groups);
    const leaveObserver = resetWhenLeavingThroughBottom(groups);

    groups.forEach((group, section) => {
        hideGroup(group);
        enterObserver.observe(section);
        leaveObserver.observe(section);
    });
}

startScrollReveal();
